import { z } from "zod";
const id = z.string().min(1).max(240);
const money = z.number().int().positive();
export const signedStripeTestReorderFinancialEventV1Schema = z
    .object({
    contract: z.literal("LC_SIGNED_STRIPE_TEST_REORDER_FINANCIAL_EVENT_V1"),
    eventId: id,
    stripeEventType: z.enum([
        "checkout.session.completed",
        "checkout.session.async_payment_succeeded",
        "charge.refunded",
        "charge.dispute.created",
        "charge.dispute.closed",
    ]),
    eventKind: z.enum(["PAID", "FULL_REFUND", "PARTIAL_REFUND", "DISPUTED"]),
    disputeOutcome: z.enum(["OPEN", "LOST"]).nullable(),
    signatureVerified: z.literal(true),
    livemode: z.literal(false),
    orderId: id,
    bookId: id,
    actorId: id,
    checkoutSessionId: z.string().startsWith("cs_test_"),
    paymentIntentId: z.string().startsWith("pi_"),
    amountMinor: money,
    affectedAmountMinor: money,
    currency: z.literal("USD"),
    occurredAt: z.string().datetime({ offset: true }),
    metadata: z
        .object({
        checkoutKind: z.literal("REORDER"),
        reorderOrderId: id,
        bookId: id,
        actorId: id,
        test: z.literal("true"),
    })
        .strict(),
})
    .strict()
    .superRefine((value, context) => {
    const paid = value.stripeEventType.startsWith("checkout.session.");
    const refunded = value.stripeEventType === "charge.refunded";
    const disputed = value.stripeEventType.startsWith("charge.dispute.");
    if ((value.eventKind === "PAID" && !paid) ||
        (["FULL_REFUND", "PARTIAL_REFUND"].includes(value.eventKind) && !refunded) ||
        (value.eventKind === "DISPUTED" && !disputed))
        context.addIssue({ code: "custom", message: "EVENT_KIND_MISMATCH" });
    if ((value.eventKind === "DISPUTED" && value.disputeOutcome === null) ||
        (value.eventKind !== "DISPUTED" && value.disputeOutcome !== null))
        context.addIssue({ code: "custom", message: "DISPUTE_OUTCOME_MISMATCH" });
    if (value.metadata.reorderOrderId !== value.orderId ||
        value.metadata.bookId !== value.bookId ||
        value.metadata.actorId !== value.actorId)
        context.addIssue({ code: "custom", message: "METADATA_IDENTITY_MISMATCH" });
    if (value.affectedAmountMinor > value.amountMinor)
        context.addIssue({ code: "custom", message: "AFFECTED_AMOUNT_EXCEEDS_TOTAL" });
    if ((value.eventKind === "PAID" || value.eventKind === "FULL_REFUND") &&
        value.affectedAmountMinor !== value.amountMinor)
        context.addIssue({ code: "custom", message: "FULL_AMOUNT_REQUIRED" });
    if (value.eventKind === "PARTIAL_REFUND" && value.affectedAmountMinor >= value.amountMinor)
        context.addIssue({ code: "custom", message: "PARTIAL_AMOUNT_REQUIRED" });
});
export const testReorderFinancialCommandV1Schema = z
    .object({
    contract: z.literal("LC_TEST_REORDER_FINANCIAL_COMMAND_V1"),
    eventId: id,
    kind: z.enum(["PAID", "REFUNDED", "DISPUTED"]),
    signatureVerified: z.literal(true),
    livemode: z.literal(false),
    orderId: id,
    bookId: id,
    actorId: id,
    checkoutSessionId: z.string().startsWith("cs_test_"),
    paymentIntentId: z.string().startsWith("pi_"),
    amountMinor: money,
    currency: z.literal("USD"),
    occurredAt: z.string().datetime({ offset: true }),
})
    .strict();
export const testReorderFinancialMappingV1Schema = z
    .object({
    contract: z.literal("LC_TEST_REORDER_FINANCIAL_MAPPING_V1"),
    decision: z.enum(["ACCEPTED_TEST_COMMAND", "RELEASE_GATED"]),
    reasonCode: z.enum(["TEST_COMMAND_READY", "PARTIAL_REFUND_POLICY_UNAVAILABLE"]),
    command: testReorderFinancialCommandV1Schema.nullable(),
    productionEligible: z.literal(false),
})
    .strict();
export const testReorderFinancialResultV1Schema = z
    .object({
    contract: z.literal("LC_TEST_REORDER_FINANCIAL_RESULT_V1"),
    state: z.enum(["PAID_EVIDENCE_RECORDED", "FINANCIAL_HOLD"]),
    duplicate: z.boolean(),
    productionEligible: z.literal(false),
})
    .strict();
export const testReorderFinancialStatusV1Schema = z
    .object({
    contract: z.literal("LC_TEST_REORDER_FINANCIAL_STATUS_V1"),
    orderId: id,
    state: z.enum(["UNKNOWN", "PAID_EVIDENCE_RECORDED", "FINANCIAL_HOLD"]),
    productionEligible: z.literal(false),
    truthBoundary: z.literal("SIGNED_TEST_EVIDENCE_ONLY_NOT_LIVE_PRICE_OR_REFUND_AUTHORITY"),
})
    .strict();
//# sourceMappingURL=book-extra-copy-financial.js.map